import { createStore, compose, applyMiddleware, UnknownAction } from 'redux'
import logger from 'redux-logger'
import { thunk, ThunkDispatch } from 'redux-thunk'
import rootReducer from './reducers/index.reducer'
import { isProduction } from 'utilities/getEnv'

const middleware: any = [thunk]
// for redux-devtool
const composeEnhancers = !isProduction()
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose

if (!isProduction()) {
    middleware.push(logger)
}

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleware)),
)
export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>
